import React from "react";
import { View } from "react-native";
import Skeletons from "./Skeletons";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";

const LiveStremObserverPlayerSkeleton = () => {
  const deviceSize = useDeviceSize();
  const isMobile =
    deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;

  if (deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE) {
    return (
      <View
        style={{
          flex: 0.2,
          marginLeft: 15,
          marginTop: 12,
          marginBottom: 12,
        }}
      >
        <Skeletons
          height={"calc(100vh - 120px - 55px - 24px)"}
          width={"100%"}
          style={{
            borderRadius: 10,
          }}
        />
      </View>
    );
  }

  // Mobile layout with new sections
  return (
    <View>
      {/* Observe Player Dropdown Skeleton */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          paddingVertical: 12,
          paddingHorizontal: 16,
          backgroundColor: "#111827",
          borderBottomWidth: 0.3,
          borderBottomColor: "rgba(139, 139, 139, 1)",
        }}
      >
        <Skeletons height={16} width="40%" style={{ borderRadius: 4 }} />
        <Skeletons height={16} width={16} style={{ borderRadius: 4 }} />
      </View>
    </View>
  );
};

export default LiveStremObserverPlayerSkeleton;
